import React, {useState, forwardRef, useEffect, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import * as S from './SearchWidget.styles';

import Icon from '../../../../../stories/core-components/IconsSelector';

import AutoSuggest from '@stencil/autosuggest';
import {searchWidgetLocationSearchURL} from './../../../../containers/Common/Api';
import {FROM_PLACEHOLDER, TO_PLACEHOLDER} from './../../../../containers/Common/Constants';
import {CalendarView} from '@stencil/dcalendar';
import dateFormat from 'dateformat';

import {commonSelector, commonDOJ} from './../../../../containers/Common/redux/selectors';
import {updateJourneyParams} from './../../../../containers/Common/redux/actions';
import {pushga} from 'ga-utils';
import {prepareSRPURL} from './../../../../containers/Common/Utils';
import {BusHomeGAEvents} from './../../../../config/ga-config';
import {setter, getter} from '@stencil/client-side-storage';
import * as AUTOS from './AutoSuggest/AutoSuggest.styles';
import getDateObj from './../../../../utils/GetDateObj';
import useOutsideClick from './../../../../hooks/useOutsideClick';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper } from '../../../../utils/ctaHelper'
import { CTA_TYPE, pushOmniEvents } from '../../../../../shared/utils/PushEvents/Omniture/utils'
import { pushWebEngageEvents } from '../../../../utils/PushEvents/WebEngage/utils';

const HomeSearchWidget = props => {
  const calendarBlockRef = React.createRef();
  
 
  useOutsideClick(calendarBlockRef, () => {
    toggleCalendar(false);

  });


  const history = useHistory();
  const dispatch = useDispatch();
  const commonData = useSelector(commonSelector);
  const recentSearchData = getter('busRecentSearches');
  const {
    doj,
    dojObj,
    src,
    dest,
    src_id,
    dest_id,
    src_vid,
    dest_vid,
    dest_name,
    src_name,
  } = commonData;

  const todaysDate = getDateObj();
  let tomorrow = getDateObj();
  let maxDateAllowed = getDateObj();
  tomorrow.setDate(tomorrow.getDate() + 1);
  maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
  const [isCalendarOpen, toggleCalendar] = useState(false);
  let storedDate = dojObj ? getDateObj(dojObj) : todaysDate;
  let dateObj = storedDate.getTime() > todaysDate.getTime() ? storedDate : todaysDate;

  const [isInputEmpty, setInputEmpty] = useState(false);
  const [isSrcDestSame,setSrcDestSame] = useState(false);
  const [srcState, setSrcState] = useState('')
  const [destState, setDestState] = useState('')
  let sourceObj={id: src_vid || '', n: src || ''}
  let destinationObj={id: dest_vid || '', n: dest || ''}
  if(recentSearchData && Object.keys(recentSearchData).length){
    const item = recentSearchData[Object.keys(recentSearchData)[Object.keys(recentSearchData).length-1]]
    if(!src){
      sourceObj={id: item.src_vid || '', n: item.src || ''}
  
    }  
    if(!dest){
      destinationObj={id: item.dest_vid || '', n: item.dest || ''}
  
   
    }
    
  }
  const [selectedDate, setSelectedDate] = useState(dateObj);
  
  let source = useRef(getautoSuggestInit(sourceObj));
  let destination = useRef(getautoSuggestInit(destinationObj));
  
    
  const getUrl = value => {
    return searchWidgetLocationSearchURL(value);
  };
  const massageData = item => {
    return item;
  };
  const itemToString = item => {
    return item.n;
  };
  const List = props => {
    return (
      <AUTOS.AutoSuggest>
        <ul>{props.children}</ul>
      </AUTOS.AutoSuggest>
    );
  };
  let inputDErr = function(){
    if(isInputEmpty && !destination.current.n){
      return (      <label data-testid="autosuggestErrorText" className="error">Please enter the TO location</label>
      )
    }
    if(isSrcDestSame){
      return (      <label data-testid="autosuggestErrorText" className="error">Source and Destination can't be same</label>
      )
    
    }
     return (    <label>TO</label>)     
   }()
   let inputErr = function(){
    if(isInputEmpty && !source.current.n){
      return (      <label data-testid="autosuggestErrorText" className="error">Please enter the FROM location</label>
      )
    }
    if(isSrcDestSame){
      return (      <label data-testid="autosuggestErrorText" className="error">Source and Destination can't be same</label>
      )
    
    }
     return (    <label>FROM</label>)     
   }()
  
  
  const Input = forwardRef((props, ref) => {
    return (
      <S.InputText>
      {inputErr}
        <input
          type="text"
          spellCheck={false}
          {...props}
          name="autosuggestBusSRPSrcHomeName"
          onFocus={(evt)=>{
            document.getElementById('autosuggestBusSRPSrcHome').value = source.current.n
            document.getElementById('autosuggestBusSRPDestHome').value = destination.current.n;
           
              }}
         
          id="autosuggestBusSRPSrcHome"
          autoFocus={true}
        />
      </S.InputText>
    );
  });
  const InputD = forwardRef((props, ref) => {
    return (
      <S.InputText>
        {inputDErr}

        <input
          type="text"
          name="autosuggestBusSRPDestHomeName"
          spellCheck={false}
      
          {...props}
          onFocus={(evt)=>{
          
            document.getElementById('autosuggestBusSRPSrcHome').value = source.current.n
            document.getElementById('autosuggestBusSRPDestHome').value = destination.current.n;
   
          }}
          id="autosuggestBusSRPDestHome"
          autoFocus={false}
     
        
        />
      </S.InputText>
    );
  });
  const itemElement = item => {
    return (
      <li>
        <Icon name="" />
        <span>{item.dn}</span>
      </li>
    );
  };
  const onSourceSelect = item => {
    source.current = item;
    if (source.current.n && destination.current.n) {
      setInputEmpty(false);
    }
    setSrcState(item?.p || '')
  };
  const onDestiantionSelect = item => {
    destination.current = item;
    if (source.current.n && destination.current.n) {
      setInputEmpty(false);
    }
    setDestState(item?.p || '')
  };
  const onSwap = () => {
    const temp = Object.assign({},destination.current);
    destination.current = Object.assign({},source.current);
    source.current = Object.assign({},temp);
    
    document.getElementById('autosuggestBusSRPSrcHome').value = source.current.n
    document.getElementById('autosuggestBusSRPDestHome').value = destination.current.n;
    
    pushga({
      event: BusHomeGAEvents.actions.bus_search,
      eventCategory: BusHomeGAEvents.category,
      eventAction: BusHomeGAEvents.actions.bus_search,
    });
 
  };

  const dateOnClickHandler = dateObj => {
    setSelectedDate(dateObj);
  };

  const getClassName = (dateObj: Date) => {
    const types = ['selectedDate', 'leftactive', 'rightactive', 'partial'];
    return types[0];
  };
  const isTodayDateSelected =
    dateFormat(selectedDate, 'yyyymmdd') === dateFormat(todaysDate, 'yyyymmdd');
  const isTommorrowDateSelected =
    dateFormat(selectedDate, 'yyyymmdd') === dateFormat(tomorrow, 'yyyymmdd');
   
  return (
    <S.SearchWidgetWrap>
      <AutoSuggest
        placeholder={FROM_PLACEHOLDER}
        getUrl={getUrl} // placeholder for input
        massageData={massageData} // in case you want to perform any processing on data call this function
        onItemSelection={onSourceSelect}
        itemToString={itemToString} // display
        itemElement={itemElement}
        Input={Input} // input field (default is plain input box as of now. can provide some                                              default css eventually)
        List={List}
        initialInputValue={source.current.n || ''}
      ></AutoSuggest>
      <S.SwapIconWrap onClick={onSwap}>
        <Icon name="SwpIcon" styleProps={{fill: 'grey', width: '3.5rem', height: '3.5rem'}} />
      </S.SwapIconWrap>

      <AutoSuggest
        placeholder={TO_PLACEHOLDER}
        getUrl={getUrl} // placeholder for input
        massageData={massageData} // in case you want to perform any processing on data call this function
        onItemSelection={onDestiantionSelect}
        itemToString={itemToString} // display
        itemElement={itemElement}
        Input={InputD} // input field (default is plain input box as of now. can provide some                                              default css eventually)
        List={List}
        initialInputValue={destination.current.n || ''}
      ></AutoSuggest>

      <S.CalendarBlock>
        <label>Travel Date</label>
        <S.DateWrapper >
          {isCalendarOpen ? (
            <S.CalendarBlockOuterWrapper ref={calendarBlockRef}>
              <CalendarView
                dateConfigForMonthToBeDisplayed={selectedDate || todaysDate}
                minDateAllowed={todaysDate}
                maxDateAllowed={maxDateAllowed}
                renderDateItem={({value, dateObj,index}) => {
                  if (!value) {
                    return (
                      <li key={"empty"+index}>
                        <span></span>
                      </li>
                    );
                  }

                  let isValid = true;

                  dateObj.setHours(0, 0, 0, 0);

                  todaysDate.setHours(0, 0, 0, 0);
                  isValid =
                    dateObj.getTime() >= todaysDate.getTime() &&
                    dateObj.getTime() < maxDateAllowed.getTime();

                  return (
                    <li
                      className={
                        dateFormat(selectedDate, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy')
                          ? getClassName(dateObj)
                          : ''
                      }
                      key={value + dateObj.getTime()}
                      style={isValid ? {color: 'black'} : {opacity: '0.4', color: 'grey'}}
                      onClick={() => {
                        if (isValid) {
                          toggleCalendar(!isCalendarOpen);

                          dateOnClickHandler(dateObj);
                        }
                      }}
                    >
                      <span>{value}</span>
                    </li>
                  );
                }}
              />
            </S.CalendarBlockOuterWrapper>
          ) : null}

          <input
            type="text"
            placeholder="Pick a date"
            data-testid="openCheckinCalendar"
            value={dateFormat(selectedDate, 'mmm d, yyyy')}
            onClick={() => {
              toggleCalendar(!isCalendarOpen);
            }}
            onChange={()=>{
            
            }}
         
          />
          {/* calendar component here */}
          <S.DateTabs>
            <span
              className={`${isTodayDateSelected ? 'active' : ''}`}
              onClick={() => {
                if (isCalendarOpen) {
                  toggleCalendar(false);
                }
                dateOnClickHandler(todaysDate);
              }}
            >
              Today, {dateFormat(todaysDate, 'ddd dd mmm')}
            </span>
            <span
            className={`${isTommorrowDateSelected ? 'active' : ''}`}
              onClick={() => {
                if (isCalendarOpen) {
                  toggleCalendar(false);
                }
                dateOnClickHandler(tomorrow);
              }}
            >
              Tomorrow
            </span>
          </S.DateTabs>
        </S.DateWrapper>
      </S.CalendarBlock>
      {/* <S.InfoBlock>
        <S.goSafeTag>
          <img src="https://gos3.ibcdn.com/social-distance-small-1592916992.png" width="33px" />
          <span>Social Distancing</span>
        </S.goSafeTag>
        <span  style={{paddingRight:'2px'}}>Introducing social distancing in select buses. </span>
        <S.Tooltip>
          Know More
          <div className="arrow_box">
            <div className="tag">
              <img src="https://gos3.ibcdn.com/social-distance-small-1592916992.png" width="25px" />
              <span>Social Distancing</span>
            </div>
            <p>
              Few bus operators are maintaining 1 seat gap between travellers for your safe travel.{' '}
            </p>
          </div>
        </S.Tooltip>
      </S.InfoBlock> */}
      <S.ButtonWrap
        onClick={() => {
        const srcValue=  document.getElementById('autosuggestBusSRPSrcHome').value 
        const destValue=  document.getElementById('autosuggestBusSRPDestHome').value
          setInputEmpty(false);
          const journeyParamsObj = {
            src: source.current.n,
            dest: destination.current.n,
            src_vid: source.current.id,
            dest_vid: destination.current.id,
            doj: dateFormat(selectedDate, 'yyyymmdd'),
            journeyType: 'onw',
            flavour: 'dweb',
            dojObj: selectedDate,
            src_name: source.current.n,
            dest_name: destination.current.n,
            srcState: srcState,
            destState: destState
          }
          if (!srcValue) {
            journeyParamsObj.src = '';
            journeyParamsObj.src_vid = '';
          }
          if (!destValue) {
            journeyParamsObj.dest = '';
            journeyParamsObj.dest_vid = '';
          }
          if( source.current?.lat && source.current?.lon){
            journeyParamsObj['srcLat'] = source.current?.lat
            journeyParamsObj['srcLon'] = source.current?.lon
          }
          if( destination.current?.lat && destination.current?.lon){
            journeyParamsObj['destLat'] = destination.current?.lat
            journeyParamsObj['destLon'] = destination.current?.lon
          }
           if(srcValue && destValue && srcValue === destValue){
             setSrcDestSame(true);
             return;
           }
          if (
            srcValue &&
            destValue && srcValue !== destValue
          ) {
          
            let recentSearches = getter('busRecentSearches');
            if (!recentSearches) {
              recentSearches = {};
            }
            const srcIndex = source.current.n.indexOf(',');
            const destIndex = destination.current.n.indexOf(',');
            const viewSrc =
              srcIndex !== -1 ? source.current.n.substring(0, srcIndex) : source.current.n;
            const viewDest =
              destIndex !== -1
                ? destination.current.n.substring(0, destIndex)
                : destination.current.n;
            const viewDate = dateFormat(selectedDate, 'dS mmm yyyy');
            const keyDate = dateFormat(selectedDate, 'ddmmyyyy');
            let key = `${viewSrc}-${viewDest}-${keyDate}`;
            recentSearches[key] = {
              src: viewSrc,
              dest: viewDest,
              date: viewDate,
              src_vid: source.current.id,
              dest_vid: destination.current.id,
              selectedDate,
            };

            setter('busRecentSearches', recentSearches);
            dispatch(updateJourneyParams(journeyParamsObj));
            dispatch({
              type:'INSERT_ROUTE_STATE',
              actionData: {srcState, destState}
            })
            const srpURL = prepareSRPURL({
              src_name: viewSrc,
              dest_name: viewDest,
              selectedDate,
              src_vid: journeyParamsObj.src_vid,
              dest_vid: journeyParamsObj.dest_vid,
            });
            history.push(srpURL);
            pushga({
              event: BusHomeGAEvents.actions.bus_search,
              eventCategory: BusHomeGAEvents.category,
              eventAction: BusHomeGAEvents.actions.bus_search,
              eventLabel: `${source.current.n}-${destination.current.n}`,
            });

            const eventDetails = {
              search : {
                  searchId: `${journeyParamsObj.src}_${journeyParamsObj.dest}_${journeyParamsObj.doj}`,
               },
              cta: ctaHelper(['Bus_search',CTA_TYPE.BUTTON,'Bus_search', 'SRP']),
              booking: {
                  routeCity: `${journeyParamsObj.src}-${journeyParamsObj.dest}`,
                  routeState: `${srcState}-${destState}`,
                  daysToTrip: `${calculateDaysToTrip(journeyParamsObj.dojObj)}`,
                  departureDate: `${convert_yyyymmdd_to_dd_mm_dddd(journeyParamsObj.doj)}`,
              },
            };
            pushOmniEvents({ eventName: 'searchBus', details: eventDetails })
            let webEngageEvtDetails = {
              fb_bus_duration: `8h20m`,
              fb_origin_country:`India`,
              fb_platform:'GI',
              fb_origin:`${viewSrc}`,
              fb_destination:`${viewDest}`,
              fb_departing_departure_date:`${dateFormat(selectedDate, 'yyyymmdd')}`,
            }
            pushWebEngageEvents({eventName : 'googleRT', details : webEngageEvtDetails})
          } else {
            dispatch(updateJourneyParams(journeyParamsObj));

            setInputEmpty(true);
          }
        }}
      >
        <button data-testid="searchBusBtn">Search Bus</button>
      </S.ButtonWrap>
    </S.SearchWidgetWrap>
  );
};
export default HomeSearchWidget;
function getautoSuggestInit(data?: {id: string | number; n: string}) {
  const {id, n} = data || {};

  return {
    id: id || '',
    n: n || '',
    dn: n || '',
  };
}
